import dayjs from 'dayjs';
import { capitalize } from 'lodash';
import { getDayjsLocale } from 'i18n/dateLocale';

export interface VisitDateParts {
  weekday: string;
  day: string;
  month: string;
  year: string;
}

const getVisitDateParts = (isoDate: string, language: string): VisitDateParts => {
  const date = dayjs(isoDate.split('T')[0]).locale(getDayjsLocale(language));

  return {
    weekday: capitalize(date.format('dddd')),
    day: date.format('D'),
    month: date.format('MMMM'),
    year: date.format('YYYY'),
  };
};

export default getVisitDateParts;
